// i18n strings for the 5 new Academy tool pages.
// Same shape per locale → page picks `T[lang] || T.es`.

const ES = {
  // common
  back: "Volver a la Academia",
  premium_required_title: "Herramientas REBEL Premium",
  premium_required_subtitle: "Esta sección es exclusiva para usuarios PRO. Desbloquea el acceso vitalicio a todas las herramientas, métricas en vivo y estrategias de los traders profesionales.",

  // calculadora
  calc_eyebrow: "Herramienta · Cero coste",
  calc_title: "Calculadora de Riesgo",
  calc_subtitle: "Calcula tu tamaño de posición, ratio R:R y precio de liquidación en tiempo real. La herramienta que usan los prop traders para no destruir su cuenta.",
  calc_breadcrumb: "Calculadora de Riesgo",
  calc_foot: "Calidad sobre cantidad — el R:R es tu mayor ventaja",
  calc_inputs: "Inputs del trade",
  calc_capital: "Capital total (€)",
  calc_risk: "Riesgo por trade",
  calc_direction: "Dirección",
  calc_long: "LONG", calc_short: "SHORT",
  calc_entry: "Precio de entrada",
  calc_sl: "Stop loss",
  calc_tp: "Take profit",
  calc_lev: "Apalancamiento",
  calc_analysis: "Análisis del setup",
  calc_risk_max: "Riesgo máximo",
  calc_potential: "Ganancia potencial",
  calc_rr: "Ratio R:R",
  calc_size: "Tamaño posición",
  calc_qty: "Cantidad",
  calc_dist_sl: "Distancia al SL",
  calc_dist_tp: "Distancia al TP",
  calc_liq: "Precio liquidación",
  calc_how_title: "¿Cómo usar la calculadora?",
  calc_how: [
    "Introduce tu capital total y elige cuánto riesgo % por trade.",
    "Selecciona dirección y escribe entrada, SL y TP del setup.",
    "Si usas futuros, elige el apalancamiento real de tu posición.",
    "Lee el R:R y el tamaño de posición sugerido.",
    "Si la calificación es «aceptable» o peor, ajusta el setup antes de operar.",
  ],
  calc_rules_title: "Reglas de oro del riesgo",
  calc_rules: [
    "Nunca arriesgues más del 1-2 % por trade.",
    "Apalancamiento alto = capital pequeño. Nunca al revés.",
    "El SL es sagrado. Si lo mueves, perdiste antes de empezar.",
    "Mínimo R:R 1:2. Los pros buscan 1:3+.",
    "Tras 2 pérdidas seguidas, cierras la plataforma.",
  ],
  calc_rr_title: "¿Qué es el ratio R:R?",
  calc_rr_text: "Es la relación entre lo que arriesgas y lo que puedes ganar. Si arriesgas 100 € para ganar 300 €, tu R:R es 1:3. Con un R:R 1:3, puedes acertar solo el 40 % de tus trades y seguir siendo rentable. El R:R es la matemática que separa al trader del gambler.",
  calc_grade: { excelente: "EXCELENTE", bueno: "BUENO", aceptable: "ACEPTABLE", malo: "MALO", peligroso: "PELIGROSO" },

  // glosario
  glo_eyebrow_prefix: "Glosario ·",
  glo_terms: "términos",
  glo_title: "Glosario de Trading",
  glo_subtitle: "Diccionario completo del trader profesional. Smart Money, análisis técnico, gestión de riesgo, cripto y macro — todo en un único lugar buscable.",
  glo_breadcrumb: "Glosario",
  glo_search: "Buscar término o palabra clave…",
  glo_all: "Todas",
  glo_empty: "Sin resultados. Prueba con otra palabra o categoría.",
  glo_view_def: "Ver definición →",
  glo_example: "Ejemplo",
  glo_related: "Términos relacionados",
  glo_categories: "categorías",
  glo_foot_prefix: "términos ·",

  // estrategias
  estr_eyebrow: "Biblioteca · Estrategias",
  estr_title: "Biblioteca de Estrategias",
  estr_subtitle: "Las estrategias que usan los traders profesionales — SMC, Wyckoff, breakouts y reversiones — con condiciones de entrada, ejemplos reales y errores comunes.",
  estr_breadcrumb: "Estrategias",
  estr_foot: "estrategias · sigue los pasos al pie de la letra",
  estr_filter_type: "Tipo",
  estr_filter_lvl: "Dificultad",
  estr_winrate: "Win rate",
  estr_rr: "R:R",
  estr_markets: "Mercados",
  estr_tf: "TF",
  estr_view: "Ver estrategia →",
  estr_entries: "Condiciones de entrada",
  estr_sl: "Stop Loss", estr_tp: "Take Profit",
  estr_example: "Ejemplo real",
  estr_errors: "Errores comunes",
  estr_tips: "Consejos PRO",
  estr_calc_cta: "Calcular R:R para este setup",
  estr_back: "← Volver a estrategias",
  estr_types: { todas: "Todas", tendencia: "Tendencia", reversion: "Reversión", ruptura: "Ruptura", rango: "Rango", scalping: "Scalping" },
  estr_levels: { todas: "Todas", basica: "Básica", intermedia: "Intermedia", avanzada: "Avanzada" },

  // psicología
  psi_eyebrow_prefix: "Módulo ·",
  psi_lessons: "lecciones",
  psi_title: "Psicología de Trading",
  psi_subtitle: "El 95% de los traders pierden dinero. No por falta de conocimiento técnico — por falta de disciplina mental. Estas lecciones tratan la otra mitad del juego.",
  psi_breadcrumb: "Psicología",
  psi_foot: "La mente es la última frontera del trader profesional",
  psi_lesson: "Lección",
  psi_read: "Leer lección →",
  psi_prev: "← Lección anterior", psi_next: "Siguiente lección →",
  psi_error: "Error #",
  psi_symptoms: "Síntomas",
  psi_solution: "Solución",
  psi_exercise: "Ejercicio práctico",

  // onchain
  och_eyebrow: "Introducción · On-Chain",
  och_title: "Análisis On-Chain",
  och_subtitle: "Lo que la blockchain ya sabe antes que tú: cómo leer los flujos de exchange, el sentimiento del mercado y los ciclos de holders para anticipar movimientos de precio.",
  och_breadcrumb: "On-Chain",
  och_foot: "métricas · combina con análisis técnico para máximo edge",
  och_intro_title: "¿Qué es el análisis on-chain?",
  och_intro_p1: "El análisis on-chain estudia los datos que circulan en la propia blockchain — transacciones, wallets, flujos de exchanges, comportamiento de mineros y holders — para inferir el sentimiento real del mercado. A diferencia del análisis técnico (que mira solo el precio) y del análisis fundamental (que mira el ecosistema), el on-chain te muestra qué están haciendo en realidad los participantes del mercado en cada momento.",
  och_intro_p2: "¿Por qué importa? Porque los institucionales no pueden esconder sus huellas en la blockchain. Cuando ves Bitcoin saliendo masivamente de los exchanges, alguien está acumulando seriamente. Cuando ves Bitcoin entrando, alguien quiere vender. Las grandes ballenas pueden mentir en Twitter, pero no en la cadena.",
  och_intro_limit: "Limitación: el on-chain confirma tendencias, no las origina. Combínalo siempre con análisis técnico para timing.",
  och_live: "Datos en vivo",
  och_now: "Ahora mismo",
  och_th_range: "Rango", och_th_signal: "Señal", och_th_read: "Lectura",
  och_resources: "Recursos externos recomendados",
  och_diff: { basica: "Básica", intermedia: "Intermedia", avanzada: "Avanzada" },
};

const EN = {
  back: "Back to Academy",
  premium_required_title: "REBEL Premium Tools",
  premium_required_subtitle: "This section is for PRO users only. Unlock lifetime access to every tool, live metric and pro-trader strategy.",

  calc_eyebrow: "Tool · No fees",
  calc_title: "Risk Calculator",
  calc_subtitle: "Compute your position size, R:R ratio and liquidation price in real-time. The tool prop traders use to keep their accounts alive.",
  calc_breadcrumb: "Risk Calculator",
  calc_foot: "Quality over quantity — R:R is your biggest edge",
  calc_inputs: "Trade inputs",
  calc_capital: "Total capital (€)",
  calc_risk: "Risk per trade",
  calc_direction: "Direction",
  calc_long: "LONG", calc_short: "SHORT",
  calc_entry: "Entry price",
  calc_sl: "Stop loss",
  calc_tp: "Take profit",
  calc_lev: "Leverage",
  calc_analysis: "Setup analysis",
  calc_risk_max: "Max risk",
  calc_potential: "Potential gain",
  calc_rr: "R:R ratio",
  calc_size: "Position size",
  calc_qty: "Quantity",
  calc_dist_sl: "Distance to SL",
  calc_dist_tp: "Distance to TP",
  calc_liq: "Liquidation price",
  calc_how_title: "How to use the calculator?",
  calc_how: [
    "Enter your total capital and choose how much % to risk per trade.",
    "Pick direction and type the setup's entry, SL and TP.",
    "If you trade futures, pick the real leverage of your position.",
    "Read the R:R and the suggested position size.",
    "If the grade is «acceptable» or worse, refine the setup before trading.",
  ],
  calc_rules_title: "Golden rules of risk",
  calc_rules: [
    "Never risk more than 1-2 % per trade.",
    "High leverage = small capital. Never the other way around.",
    "Your SL is sacred. If you move it, you've lost before you started.",
    "Minimum R:R 1:2. Pros aim for 1:3+.",
    "After 2 consecutive losses, close the platform.",
  ],
  calc_rr_title: "What is the R:R ratio?",
  calc_rr_text: "It's the relationship between what you risk and what you can win. Risking €100 to gain €300 is a 1:3 R:R. With 1:3 R:R you can be right only 40 % of the time and still be profitable. R:R is the math that separates a trader from a gambler.",
  calc_grade: { excelente: "EXCELLENT", bueno: "GOOD", aceptable: "ACCEPTABLE", malo: "BAD", peligroso: "DANGEROUS" },

  glo_eyebrow_prefix: "Glossary ·",
  glo_terms: "terms",
  glo_title: "Trading Glossary",
  glo_subtitle: "The pro trader's full dictionary. Smart Money, technical analysis, risk management, crypto and macro — all in one searchable place.",
  glo_breadcrumb: "Glossary",
  glo_search: "Search term or keyword…",
  glo_all: "All",
  glo_empty: "No matches. Try another keyword or category.",
  glo_view_def: "Read definition →",
  glo_example: "Example",
  glo_related: "Related terms",
  glo_categories: "categories",
  glo_foot_prefix: "terms ·",

  estr_eyebrow: "Library · Strategies",
  estr_title: "Strategy Library",
  estr_subtitle: "The strategies used by pro traders — SMC, Wyckoff, breakouts and reversals — with entry conditions, real examples and common mistakes.",
  estr_breadcrumb: "Strategies",
  estr_foot: "strategies · follow the steps to the letter",
  estr_filter_type: "Type",
  estr_filter_lvl: "Level",
  estr_winrate: "Win rate",
  estr_rr: "R:R",
  estr_markets: "Markets",
  estr_tf: "TF",
  estr_view: "View strategy →",
  estr_entries: "Entry conditions",
  estr_sl: "Stop Loss", estr_tp: "Take Profit",
  estr_example: "Real example",
  estr_errors: "Common mistakes",
  estr_tips: "PRO tips",
  estr_calc_cta: "Calculate R:R for this setup",
  estr_back: "← Back to strategies",
  estr_types: { todas: "All", tendencia: "Trend", reversion: "Reversal", ruptura: "Breakout", rango: "Range", scalping: "Scalping" },
  estr_levels: { todas: "All", basica: "Basic", intermedia: "Intermediate", avanzada: "Advanced" },

  psi_eyebrow_prefix: "Module ·",
  psi_lessons: "lessons",
  psi_title: "Trading Psychology",
  psi_subtitle: "95% of traders lose money. Not from lack of technical knowledge — from lack of mental discipline. These lessons cover the other half of the game.",
  psi_breadcrumb: "Psychology",
  psi_foot: "The mind is the pro trader's last frontier",
  psi_lesson: "Lesson",
  psi_read: "Read lesson →",
  psi_prev: "← Previous lesson", psi_next: "Next lesson →",
  psi_error: "Mistake #",
  psi_symptoms: "Symptoms",
  psi_solution: "Solution",
  psi_exercise: "Practical exercise",

  och_eyebrow: "Intro · On-Chain",
  och_title: "On-Chain Analysis",
  och_subtitle: "What the blockchain already knows before you do: how to read exchange flows, market sentiment and holder cycles to anticipate price moves.",
  och_breadcrumb: "On-Chain",
  och_foot: "metrics · combine with TA for maximum edge",
  och_intro_title: "What is on-chain analysis?",
  och_intro_p1: "On-chain analysis studies the data flowing across the blockchain itself — transactions, wallets, exchange flows, miner and holder behavior — to infer the market's real sentiment. Unlike technical analysis (price only) and fundamental analysis (ecosystem), on-chain shows you what market participants are actually doing in real time.",
  och_intro_p2: "Why it matters: institutionals can't hide their footprints on the blockchain. When Bitcoin flows massively out of exchanges, someone is accumulating seriously. When BTC flows in, someone wants to sell. Whales can lie on Twitter — they can't lie on chain.",
  och_intro_limit: "Limitation: on-chain confirms trends, it doesn't trigger them. Always combine with TA for timing.",
  och_live: "Live data",
  och_now: "Right now",
  och_th_range: "Range", och_th_signal: "Signal", och_th_read: "Reading",
  och_resources: "Recommended external resources",
  och_diff: { basica: "Basic", intermedia: "Intermediate", avanzada: "Advanced" },
};

const SK = {
  back: "Späť na Akadémiu",
  premium_required_title: "REBEL Premium Nástroje",
  premium_required_subtitle: "Táto sekcia je iba pre PRO používateľov. Odomkni doživotný prístup ku všetkým nástrojom, live metrikám a stratégiám profesionálov.",

  calc_eyebrow: "Nástroj · Bez poplatkov",
  calc_title: "Kalkulačka rizika",
  calc_subtitle: "Spočítaj veľkosť pozície, pomer R:R a likvidačnú cenu v reálnom čase. Nástroj, ktorý prop traderi používajú, aby si nezničili účet.",
  calc_breadcrumb: "Kalkulačka rizika",
  calc_foot: "Kvalita nad kvantitou — R:R je tvoja najväčšia výhoda",
  calc_inputs: "Vstupy obchodu",
  calc_capital: "Celkový kapitál (€)",
  calc_risk: "Riziko na obchod",
  calc_direction: "Smer",
  calc_long: "LONG", calc_short: "SHORT",
  calc_entry: "Vstupná cena",
  calc_sl: "Stop loss",
  calc_tp: "Take profit",
  calc_lev: "Páka",
  calc_analysis: "Analýza setupu",
  calc_risk_max: "Max. riziko",
  calc_potential: "Potenciálny zisk",
  calc_rr: "Pomer R:R",
  calc_size: "Veľkosť pozície",
  calc_qty: "Množstvo",
  calc_dist_sl: "Vzdialenosť k SL",
  calc_dist_tp: "Vzdialenosť k TP",
  calc_liq: "Likvidačná cena",
  calc_how_title: "Ako používať kalkulačku?",
  calc_how: [
    "Zadaj celkový kapitál a zvoľ koľko % riskuješ na obchod.",
    "Vyber smer a napíš vstup, SL a TP setupu.",
    "Ak obchoduješ futures, zvoľ reálnu páku tvojej pozície.",
    "Prečítaj si R:R a navrhovanú veľkosť pozície.",
    "Ak je hodnotenie «prijateľné» alebo horšie, uprav setup pred obchodom.",
  ],
  calc_rules_title: "Zlaté pravidlá rizika",
  calc_rules: [
    "Nikdy nerizikuj viac ako 1-2 % na obchod.",
    "Vysoká páka = malý kapitál. Nikdy naopak.",
    "SL je posvätný. Ak ho hýbeš, prehral si skôr ako si začal.",
    "Minimálne R:R 1:2. Profesionáli mieria na 1:3+.",
    "Po 2 stratových obchodoch zavri platformu.",
  ],
  calc_rr_title: "Čo je pomer R:R?",
  calc_rr_text: "Je to vzťah medzi tým, čo riskuješ a tým, čo môžeš získať. Riziko 100 € pre zisk 300 € je R:R 1:3. Pri R:R 1:3 môžeš mať pravdu len v 40 % obchodov a stále byť ziskový. R:R je matematika, ktorá oddeľuje tradera od gamblera.",
  calc_grade: { excelente: "VÝBORNÉ", bueno: "DOBRÉ", aceptable: "PRIJATEĽNÉ", malo: "ZLÉ", peligroso: "NEBEZPEČNÉ" },

  glo_eyebrow_prefix: "Slovník ·",
  glo_terms: "pojmov",
  glo_title: "Trading Slovník",
  glo_subtitle: "Kompletný slovník profesionálneho tradera. Smart Money, technická analýza, risk manažment, krypto a makro — všetko na jednom mieste s vyhľadávaním.",
  glo_breadcrumb: "Slovník",
  glo_search: "Hľadať pojem alebo kľúčové slovo…",
  glo_all: "Všetky",
  glo_empty: "Žiadne výsledky. Skús iné slovo alebo kategóriu.",
  glo_view_def: "Zobraziť definíciu →",
  glo_example: "Príklad",
  glo_related: "Súvisiace pojmy",
  glo_categories: "kategórií",
  glo_foot_prefix: "pojmov ·",

  estr_eyebrow: "Knižnica · Stratégie",
  estr_title: "Knižnica Stratégií",
  estr_subtitle: "Stratégie, ktoré používajú profesionáli — SMC, Wyckoff, breakouty a reverzy — so vstupnými podmienkami, reálnymi príkladmi a častými chybami.",
  estr_breadcrumb: "Stratégie",
  estr_foot: "stratégií · postupuj presne podľa krokov",
  estr_filter_type: "Typ",
  estr_filter_lvl: "Obtiažnosť",
  estr_winrate: "Win rate",
  estr_rr: "R:R",
  estr_markets: "Trhy",
  estr_tf: "TF",
  estr_view: "Zobraziť stratégiu →",
  estr_entries: "Vstupné podmienky",
  estr_sl: "Stop Loss", estr_tp: "Take Profit",
  estr_example: "Reálny príklad",
  estr_errors: "Časté chyby",
  estr_tips: "PRO tipy",
  estr_calc_cta: "Spočítať R:R pre tento setup",
  estr_back: "← Späť na stratégie",
  estr_types: { todas: "Všetky", tendencia: "Trend", reversion: "Reverz", ruptura: "Breakout", rango: "Range", scalping: "Scalping" },
  estr_levels: { todas: "Všetky", basica: "Základná", intermedia: "Stredná", avanzada: "Pokročilá" },

  psi_eyebrow_prefix: "Modul ·",
  psi_lessons: "lekcií",
  psi_title: "Psychológia Tradingu",
  psi_subtitle: "95% traderov stráca peniaze. Nie kvôli technickým znalostiam — kvôli mentálnej disciplíne. Tieto lekcie pokrývajú druhú polovicu hry.",
  psi_breadcrumb: "Psychológia",
  psi_foot: "Myseľ je posledná hranica profesionálneho tradera",
  psi_lesson: "Lekcia",
  psi_read: "Prečítať lekciu →",
  psi_prev: "← Predošlá lekcia", psi_next: "Ďalšia lekcia →",
  psi_error: "Chyba #",
  psi_symptoms: "Symptómy",
  psi_solution: "Riešenie",
  psi_exercise: "Praktické cvičenie",

  och_eyebrow: "Úvod · On-Chain",
  och_title: "On-Chain Analýza",
  och_subtitle: "Čo blockchain vie skôr ako ty: ako čítať toky burz, sentiment trhu a cykly holderov, aby si predpovedal pohyby ceny.",
  och_breadcrumb: "On-Chain",
  och_foot: "metrík · kombinuj s TA pre maximálnu výhodu",
  och_intro_title: "Čo je on-chain analýza?",
  och_intro_p1: "On-chain analýza študuje dáta priamo z blockchainu — transakcie, peňaženky, toky burz, správanie minerov a holderov — aby odvodila skutočný sentiment trhu. Na rozdiel od TA (iba cena) a fundamentálnej analýzy (ekosystém), on-chain ukazuje, čo účastníci trhu skutočne robia v reálnom čase.",
  och_intro_p2: "Prečo je to dôležité: inštitucionálni hráči nemôžu skryť svoje stopy na blockchaine. Keď Bitcoin masívne uteká z búrz, niekto seriózne akumuluje. Keď BTC prichádza na burzy, niekto chce predať. Veľryby môžu klamať na Twitteri — na chaine nie.",
  och_intro_limit: "Obmedzenie: on-chain potvrdzuje trendy, nespúšťa ich. Vždy kombinuj s TA pre časovanie.",
  och_live: "Live dáta",
  och_now: "Práve teraz",
  och_th_range: "Rozsah", och_th_signal: "Signál", och_th_read: "Čítanie",
  och_resources: "Odporúčané externé zdroje",
  och_diff: { basica: "Základná", intermedia: "Stredná", avanzada: "Pokročilá" },
};

const DE = {
  back: "Zurück zur Akademie",
  premium_required_title: "RE₿EL Premium-Tools",
  premium_required_subtitle: "Dieser Bereich ist exklusiv für PRO-Nutzer. Schalte lebenslangen Zugang zu allen Tools, Live-Metriken und Strategien professioneller Trader frei.",
  calc_eyebrow: "Tool · Kostenfrei",
  calc_title: "Risiko-Rechner",
  calc_subtitle: "Berechne deine Positionsgröße, R:R-Verhältnis und Liquidation-Preis in Echtzeit. Das Tool, das Prop-Trader nutzen, um ihr Konto nicht zu zerstören.",
  calc_breadcrumb: "Risiko-Rechner",
  calc_foot: "Qualität über Quantität — das R:R ist dein größter Vorteil",
  calc_inputs: "Trade-Inputs",
  calc_capital: "Gesamtkapital (€)",
  calc_risk: "Risiko pro Trade",
  calc_direction: "Richtung",
  calc_long: "LONG",
  calc_short: "SHORT",
  calc_entry: "Einstiegspreis",
  calc_sl: "Stop Loss",
  calc_tp: "Take Profit",
  calc_lev: "Hebel",
  calc_analysis: "Setup-Analyse",
  calc_risk_max: "Maximales Risiko",
  calc_potential: "Potenzieller Gewinn",
  calc_rr: "R:R-Verhältnis",
  calc_size: "Positionsgröße",
  calc_qty: "Menge",
  calc_dist_sl: "Distanz zum SL",
  calc_dist_tp: "Distanz zum TP",
  calc_liq: "Liquidation-Preis",
  calc_how_title: "Wie benutzt man den Rechner?",
  calc_how: [
    "Gib dein Gesamtkapital ein und wähle, wie viel Risiko % pro Trade.",
    "Wähle die Richtung und trage Einstieg, SL und TP des Setups ein.",
    "Wenn du Futures nutzt, wähle den realen Hebel deiner Position.",
    "Lies das R:R und die vorgeschlagene Positionsgröße ab.",
    "Wenn die Bewertung \"akzeptabel\" oder schlechter ist, passe das Setup an, bevor du tradest."
  ],
  calc_rules_title: "Goldene Regeln des Risikos",
  calc_rules: [
    "Riskiere niemals mehr als 1-2 % pro Trade.",
    "Hoher Hebel = kleines Kapital. Niemals umgekehrt.",
    "Der SL ist heilig. Wenn du ihn verschiebst, hast du schon verloren, bevor du angefangen hast.",
    "Minimum R:R 1:2. Die Profis suchen 1:3+.",
    "Nach 2 Verlusten hintereinander schließt du die Plattform."
  ],
  calc_rr_title: "Was ist das R:R-Verhältnis?",
  calc_rr_text: "Es ist das Verhältnis zwischen dem, was du riskierst, und dem, was du gewinnen kannst. Wenn du 100 € riskierst, um 300 € zu gewinnen, ist dein R:R 1:3. Mit einem R:R von 1:3 kannst du nur 40 % deiner Trades richtig liegen und trotzdem profitabel sein. Das R:R ist die Mathematik, die den Trader vom Gambler trennt.",
  calc_grade: {
    excelente: "EXZELLENT",
    bueno: "GUT",
    aceptable: "AKZEPTABEL",
    malo: "SCHLECHT",
    peligroso: "GEFÄHRLICH",
  },
  glo_eyebrow_prefix: "Glossar ·",
  glo_terms: "Begriffe",
  glo_title: "Trading-Glossar",
  glo_subtitle: "Vollständiges Wörterbuch des professionellen Traders. Smart Money, technische Analyse, Risikomanagement, Krypto und Makro — alles an einem durchsuchbaren Ort.",
  glo_breadcrumb: "Glossar",
  glo_search: "Begriff oder Stichwort suchen…",
  glo_all: "Alle",
  glo_empty: "Keine Ergebnisse. Versuche ein anderes Wort oder eine andere Kategorie.",
  glo_view_def: "Definition ansehen →",
  glo_example: "Beispiel",
  glo_related: "Verwandte Begriffe",
  glo_categories: "Kategorien",
  glo_foot_prefix: "Begriffe ·",
  estr_eyebrow: "Bibliothek · Strategien",
  estr_title: "Strategie-Bibliothek",
  estr_subtitle: "Die Strategien, die professionelle Trader nutzen — SMC, Wyckoff, Breakouts und Reversionen — mit Einstiegsbedingungen, echten Beispielen und häufigen Fehlern.",
  estr_breadcrumb: "Strategien",
  estr_foot: "Strategien · folge den Schritten aufs Wort",
  estr_filter_type: "Typ",
  estr_filter_lvl: "Schwierigkeit",
  estr_winrate: "Win Rate",
  estr_rr: "R:R",
  estr_markets: "Märkte",
  estr_tf: "TF",
  estr_view: "Strategie ansehen →",
  estr_entries: "Einstiegsbedingungen",
  estr_sl: "Stop Loss",
  estr_tp: "Take Profit",
  estr_example: "Echtes Beispiel",
  estr_errors: "Häufige Fehler",
  estr_tips: "PRO-Tipps",
  estr_calc_cta: "R:R für dieses Setup berechnen",
  estr_back: "← Zurück zu Strategien",
  estr_types: {
    todas: "Alle",
    tendencia: "Trend",
    reversion: "Reversion",
    ruptura: "Ausbruch",
    rango: "Range",
    scalping: "Scalping",
  },
  estr_levels: {
    todas: "Alle",
    basica: "Basis",
    intermedia: "Mittel",
    avanzada: "Fortgeschritten",
  },
  psi_eyebrow_prefix: "Modul ·",
  psi_lessons: "Lektionen",
  psi_title: "Trading-Psychologie",
  psi_subtitle: "95 % der Trader verlieren Geld. Nicht aus Mangel an technischem Wissen — sondern aus Mangel an mentaler Disziplin. Diese Lektionen behandeln die andere Hälfte des Spiels.",
  psi_breadcrumb: "Psychologie",
  psi_foot: "Der Geist ist die letzte Grenze des professionellen Traders",
  psi_lesson: "Lektion",
  psi_read: "Lektion lesen →",
  psi_prev: "← Vorherige Lektion",
  psi_next: "Nächste Lektion →",
  psi_error: "Fehler #",
  psi_symptoms: "Symptome",
  psi_solution: "Lösung",
  psi_exercise: "Praktische Übung",
  och_eyebrow: "Einführung · On-Chain",
  och_title: "On-Chain-Analyse",
  och_subtitle: "Was die Blockchain bereits weiß, bevor du es tust: Wie man Exchange-Flows, Marktstimmung und Holder-Zyklen liest, um Preisbewegungen vorherzusehen.",
  och_breadcrumb: "On-Chain",
  och_foot: "Metriken · kombiniere mit technischer Analyse für maximalen Edge",
  och_intro_title: "Was ist On-Chain-Analyse?",
  och_intro_p1: "Die On-Chain-Analyse untersucht die Daten, die in der Blockchain selbst zirkulieren — Transaktionen, Wallets, Exchange-Flows, Miner- und Holder-Verhalten — um die echte Marktstimmung abzuleiten. Im Gegensatz zur technischen Analyse (die nur den Preis betrachtet) und zur Fundamentalanalyse (die das Ökosystem betrachtet) zeigt dir die On-Chain-Analyse, was die Marktteilnehmer tatsächlich in jedem Moment tun.",
  och_intro_p2: "Warum ist das wichtig? Weil institutionelle Akteure ihre Spuren in der Blockchain nicht verbergen können. Wenn du siehst, dass Bitcoin massiv von den Exchanges abfließt, akkumuliert jemand ernsthaft. Wenn du siehst, dass Bitcoin zufließt, will jemand verkaufen. Die großen Wale können auf Twitter lügen, aber nicht in der Kette.",
  och_intro_limit: "Einschränkung: On-Chain bestätigt Trends, löst sie aber nicht aus. Kombiniere es immer mit technischer Analyse für das Timing.",
  och_live: "Live-Daten",
  och_now: "Jetzt gerade",
  och_th_range: "Bereich",
  och_th_signal: "Signal",
  och_th_read: "Deutung",
  och_resources: "Empfohlene externe Ressourcen",
  och_diff: {
    basica: "Basis",
    intermedia: "Mittel",
    avanzada: "Fortgeschritten",
  },
};

const ZH_CN = {
  back: "返回学院",
  premium_required_title: "RE₿EL Premium 工具",
  premium_required_subtitle: "本部分仅供 PRO 用户使用。解锁终身访问所有工具、实时指标和专业交易者策略。",
  calc_eyebrow: "工具 · 零成本",
  calc_title: "风险计算器",
  calc_subtitle: "实时计算仓位大小、R:R 比率和强制平仓价格。专业交易员用来避免爆仓的工具。",
  calc_breadcrumb: "风险计算器",
  calc_foot: "质量胜于数量 — R:R 是你最大的优势",
  calc_inputs: "交易输入",
  calc_capital: "总资金 (€)",
  calc_risk: "每笔交易风险",
  calc_direction: "方向",
  calc_long: "做多",
  calc_short: "做空",
  calc_entry: "入场价格",
  calc_sl: "止损",
  calc_tp: "止盈",
  calc_lev: "杠杆",
  calc_analysis: "设置分析",
  calc_risk_max: "最大风险",
  calc_potential: "潜在收益",
  calc_rr: "R:R 比率",
  calc_size: "仓位大小",
  calc_qty: "数量",
  calc_dist_sl: "到止损距离",
  calc_dist_tp: "到止盈距离",
  calc_liq: "强制平仓价格",
  calc_how_title: "如何使用计算器?",
  calc_how: [
    "输入总资金并选择每笔交易的风险百分比。",
    "选择方向并输入设置的入场、止损和止盈价格。",
    "如果使用期货，选择实际仓位的杠杆。",
    "查看 R:R 和建议的仓位大小。",
    "如果评级为「可接受」或更差，在交易前调整设置。"
  ],
  calc_rules_title: "风险黄金法则",
  calc_rules: [
    "每笔交易绝不冒险超过 1-2%。",
    "高杠杆 = 小资金。绝不反过来。",
    "止损是神圣的。如果你移动它，你在开始前就已经输了。",
    "最低 R:R 1:2。专业人士追求 1:3+。",
    "连续亏损 2 次后，关闭平台。"
  ],
  calc_rr_title: "什么是 R:R 比率?",
  calc_rr_text: "这是你冒险和可能获得的收益之间的关系。如果你冒险 100 € 以赚取 300 €，你的 R:R 是 1:3。使用 1:3 的 R:R，你只需正确 40% 的交易就能保持盈利。R:R 是将交易者与赌徒分开的数学。",
  calc_grade: {
    excelente: "优秀",
    bueno: "良好",
    aceptable: "可接受",
    malo: "差",
    peligroso: "危险",
  },
  glo_eyebrow_prefix: "词汇表 ·",
  glo_terms: "术语",
  glo_title: "交易词汇表",
  glo_subtitle: "专业交易者完整词典。Smart Money、技术分析、风险管理、加密货币和宏观 — 全部集中在一个可搜索的地方。",
  glo_breadcrumb: "词汇表",
  glo_search: "搜索术语或关键词…",
  glo_all: "全部",
  glo_empty: "无结果。尝试其他词或类别。",
  glo_view_def: "查看定义 →",
  glo_example: "示例",
  glo_related: "相关术语",
  glo_categories: "类别",
  glo_foot_prefix: "术语 ·",
  estr_eyebrow: "资源库 · 策略",
  estr_title: "策略库",
  estr_subtitle: "专业交易者使用的策略 — SMC、Wyckoff、突破和反转 — 包含入场条件、真实示例和常见错误。",
  estr_breadcrumb: "策略",
  estr_foot: "策略 · 严格按照步骤执行",
  estr_filter_type: "类型",
  estr_filter_lvl: "难度",
  estr_winrate: "胜率",
  estr_rr: "R:R",
  estr_markets: "市场",
  estr_tf: "时间框架",
  estr_view: "查看策略 →",
  estr_entries: "入场条件",
  estr_sl: "止损",
  estr_tp: "止盈",
  estr_example: "真实示例",
  estr_errors: "常见错误",
  estr_tips: "PRO 提示",
  estr_calc_cta: "计算此设置的 R:R",
  estr_back: "← 返回策略",
  estr_types: {
    todas: "全部",
    tendencia: "趋势",
    reversion: "反转",
    ruptura: "突破",
    rango: "区间",
    scalping: "Scalping",
  },
  estr_levels: {
    todas: "全部",
    basica: "基础",
    intermedia: "中级",
    avanzada: "高级",
  },
  psi_eyebrow_prefix: "模块 ·",
  psi_lessons: "课程",
  psi_title: "交易心理学",
  psi_subtitle: "95% 的交易者亏损。不是因为缺乏技术知识 — 而是缺乏心理纪律。这些课程讲述游戏的另一半。",
  psi_breadcrumb: "心理学",
  psi_foot: "思维是专业交易者的最后前沿",
  psi_lesson: "课程",
  psi_read: "阅读课程 →",
  psi_prev: "← 上一课程",
  psi_next: "下一课程 →",
  psi_error: "错误 #",
  psi_symptoms: "症状",
  psi_solution: "解决方案",
  psi_exercise: "实践练习",
  och_eyebrow: "介绍 · On-Chain",
  och_title: "链上分析",
  och_subtitle: "区块链比你更早知道的事情: 如何读取交易所流动、市场情绪和持有者周期以预测价格走势。",
  och_breadcrumb: "链上",
  och_foot: "指标 · 结合技术分析以获得最大优势",
  och_intro_title: "什么是链上分析?",
  och_intro_p1: "链上分析研究在区块链本身流通的数据 — 交易、钱包、交易所流动、矿工和持有者行为 — 以推断市场的真实情绪。与技术分析(只看价格)和基本面分析(看生态系统)不同，链上分析向你展示市场参与者在每个时刻实际在做什么。",
  och_intro_p2: "为什么重要? 因为机构无法在区块链上隐藏他们的足迹。当你看到 Bitcoin 大量流出交易所时，有人在认真积累。当你看到 Bitcoin 流入时，有人想卖出。大巨鲸可以在 Twitter 上撒谎，但无法在链上撒谎。",
  och_intro_limit: "局限性: 链上确认趋势，而不是创造趋势。始终与技术分析结合以获得时机。",
  och_live: "实时数据",
  och_now: "当前",
  och_th_range: "范围",
  och_th_signal: "信号",
  och_th_read: "解读",
  och_resources: "推荐外部资源",
  och_diff: {
    basica: "基础",
    intermedia: "中级",
    avanzada: "高级",
  },
};

const ALL = { es: ES, en: EN, sk: SK, de: DE, "zh-CN": ZH_CN };

export const getAcademyToolsI18n = (lang) => ALL[lang] || ALL.es;
